import axios from "axios";
import { configureUnauthorizedInterceptor } from "./configureUnauthorizedInterceptor";
import { configureAuthHeaderInterceptor } from "./configureAuthHeaderInterceptor";
import { configureCouncilHeaderInterceptor } from "./configureCouncilHeaderInterceptor";
import { configureHeaderToIndicateRequestIsAnAjaxOne } from "./configureHeaderToIndicateRequestIsAnAjaxOne";
import appSettings from "@/plumbing/ApplicationSettings";

axios.defaults.baseURL = `${appSettings.apiBaseUrl}/api`;

// Request
configureHeaderToIndicateRequestIsAnAjaxOne();
configureAuthHeaderInterceptor();
configureCouncilHeaderInterceptor();

// Response
configureUnauthorizedInterceptor();
